import { Logger, LOGGER_DAYS_TO_KEEP } from "../../../services/logging-service";
import { Button } from "react-bootstrap";
import useDevMenuStore from "../../../stores/DevMenuStore";

const HiddenDevTools = () => {
  const { isDevMenuOpen, setDevMenu } = useDevMenuStore();

  return (
    <>
      {isDevMenuOpen && (
        <div style={adminPanelStyle}>
          <h4>Fejlesztői eszközök</h4>
          <div
            style={{ display: "flex", gap: "10px", flexDirection: "column" }}
          >
            <Button variant="primary" onClick={() => Logger.exportLogs()}>
              Utolsó {LOGGER_DAYS_TO_KEEP} nap logjainak exportálása
            </Button>

            <Button
              variant="danger"
              onClick={() => {
                if (
                  window.confirm("Törölni szeretné az összes elmentett logot?")
                ) {
                  Logger.clearLogs();
                }
              }}
            >
              Összes log törlése
            </Button>

            <Button variant="secondary" onClick={() => setDevMenu(false)}>
              Bezárás
            </Button>
          </div>
        </div>
      )}
    </>
  );
};

// Simple styles for the mobile overlay
const adminPanelStyle = {
  position: "fixed",
  bottom: "20px",
  left: "20px",
  right: "20px",
  background: "#e9ecef",
  color: "#000",
  padding: "20px",
  borderRadius: "12px",
  zIndex: 1000,
  boxShadow: "0 4px 20px rgba(0,0,0,0.5)",
};

export default HiddenDevTools;
